module.exports = __webpack_public_path__ + "static/media/ra.eca4b722.png";